// AlignUI · иллюстрация пустого состояния: портрет человека
//
// Перенесена скриптом из набора дизайн-системы, руками не правится. Цвета заменены на
// семантические классы: под ними лежат переменные `--illustration-*`, у которых в тёмной
// теме своя ступень серого. Без этого картинка светилась бы белым пятном на тёмном экране.

import type { SVGProps } from 'react';

export function IllustrationЛюди(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 148 148' fill='none' {...props}>
      <rect className='fill-illustration-weak-100' width='148' height='148' rx='74' />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M129 109C129 109 123 109.02 123 115C123 109.02 117 109 117 109C117 109 123 108.98 123 103C123 108.98 129 109 129 109Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M24 26C24 26 18 26.0204 18 32C18 26.0204 12 26 12 26C12 26 18 25.9796 18 20C18 25.9796 24 26 24 26Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        x='26.9715'
        y='45.2528'
        width='70.2668'
        height='78.7472'
        rx='4.46724'
        strokeLinejoin='round'
      />
      <rect
        className='fill-illustration-weak-100 stroke-illustration-strong-400'
        x='33.5998'
        y='35.9283'
        width='70.2668'
        height='78.7472'
        rx='4.46724'
        strokeLinejoin='round'
      />
      <rect
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        x='41.9061'
        y='45.253'
        width='53.654'
        height='53.1637'
        strokeLinejoin='round'
      />
      <rect
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        x='41.9061'
        y='45.2528'
        width='53.654'
        height='53.1637'
        strokeLinejoin='round'
      />
      <ellipse
        className='fill-illustration-strong-400 stroke-illustration-strong-400'
        cx='68.8108'
        cy='63.7189'
        rx='10.65'
        ry='11.076'
        strokeMiterlimit='10'
      />
      <path
        className='fill-illustration-strong-400 stroke-illustration-strong-400'
        d='M91.7534 97.8149C91.7534 94.7919 91.1579 91.7985 90.0011 89.0056C88.8442 86.2127 87.1486 83.675 85.011 81.5374C82.8734 79.3998 80.3357 77.7041 77.5428 76.5473C74.7499 75.3904 71.7564 74.795 68.7334 74.795C65.7104 74.795 62.717 75.3904 59.9241 76.5473C57.1312 77.7041 54.5935 79.3998 52.4559 81.5374C50.3183 83.675 48.6226 86.2127 47.4658 89.0056C46.3089 91.7985 45.7135 94.7919 45.7135 97.8149L91.7534 97.8149Z'
        strokeMiterlimit='10'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M89.1523 55.9415L103.866 59.884L97.6326 83.1479L92.7798 71.8312L82.9188 79.2053L89.1523 55.9415Z'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M118.58 55.9415L103.866 59.884L110.099 83.1479L114.952 71.8312L124.813 79.2053L118.58 55.9415Z'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M99.5842 18.6407C101.516 15.3937 106.217 15.3937 108.148 18.6407C109.426 20.7898 112.1 21.6585 114.397 20.6711C117.868 19.1795 121.672 21.9428 121.325 25.7049C121.096 28.1949 122.749 30.469 125.188 31.0206C128.872 31.854 130.325 36.3252 127.834 39.1654C126.185 41.0452 126.185 43.8562 127.834 45.736C130.325 48.5762 128.872 53.0473 125.188 53.8808C122.749 54.4324 121.096 56.7065 121.325 59.1965C121.672 62.9586 117.868 65.7219 114.397 64.2303C112.1 63.2429 109.426 64.1116 108.148 66.2607C106.217 69.5077 101.516 69.5077 99.5842 66.2607C98.3059 64.1116 95.6325 63.2429 93.3351 64.2303C89.8641 65.7219 86.0607 62.9586 86.4068 59.1965C86.6359 56.7065 84.9836 54.4324 82.5447 53.8808C78.8598 53.0473 77.407 48.5762 79.8983 45.736C81.5472 43.8562 81.5472 41.0452 79.8983 39.1654C77.407 36.3252 78.8598 31.854 82.5447 31.0206C84.9836 30.469 86.6359 28.1949 86.4068 25.7049C86.0607 21.9428 89.8641 19.1795 93.3351 20.6711C95.6325 21.6585 98.3059 20.7898 99.5842 18.6407Z'
      />
      <circle
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        cx='103.866'
        cy='42.4505'
        r='16.3701'
      />
      <path
        className='fill-illustration-strong-400'
        d='M94.0006 37.9911L96.5865 40.5599L93.9264 43.2377C93.6551 43.5108 93.6566 43.952 93.9296 44.2233C94.2027 44.4945 94.644 44.4931 94.9152 44.22L98.0665 41.0478C98.3377 40.7747 98.3363 40.3335 98.0632 40.0622L94.9829 37.0022C94.7098 36.731 94.2685 36.7324 93.9973 37.0055C93.726 37.2786 93.7275 37.7199 94.0006 37.9911Z'
      />
      <path
        className='fill-illustration-strong-400'
        d='M113.101 36.942L110.041 40.0223C109.912 40.1525 109.838 40.3323 109.838 40.5158C109.839 40.6993 109.914 40.8786 110.044 41.0079L113.216 44.1592C113.49 44.4304 113.931 44.4289 114.202 44.1559C114.473 43.8828 114.472 43.4415 114.199 43.1703L111.521 40.5102L114.09 37.9243C114.361 37.6513 114.36 37.21 114.087 36.9387C113.813 36.6675 113.372 36.6689 113.101 36.942Z'
      />
      <path
        className='fill-illustration-strong-400'
        d='M99.1176 49.5574L109.059 49.5245C109.444 49.5232 109.755 49.2102 109.754 48.8253C109.752 48.4404 109.439 48.1294 109.054 48.1307L99.1129 48.1636C98.728 48.1649 98.4171 48.478 98.4183 48.8629C98.4196 49.2477 98.7327 49.5587 99.1176 49.5574Z'
      />
    </svg>
  );
}
